import { useEffect } from "react";
import { createPortal } from "react-dom";
import useEscapeKey from "../utils/useEscapeKey";

const Modal = ({ onClose, children }) => {
  useEscapeKey(onClose);

  // Lås sidan bakom så bara modalen scrollar
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Portal till body så att transform på förälderelement (t.ex. MotionDiv) inte påverkar position: fixed
  return createPortal(
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-950/80 backdrop-blur-sm" onClick={onClose}>
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
